import { ReactNode } from 'react';
import styled from 'styled-components';

import { Link } from '@sorare/routing';

import { Vertical } from 'atoms/layout/flex';
import { BodyM, BodyS } from 'atoms/typography';
import { PlayerAvatar } from 'components/seo/PlayerAvatar';
import { Row } from 'components/seo/ui';

import { Country } from '../../Infos/Country';

const StyledBodyS = styled(BodyS)`
  display: flex;
  gap: var(--half-unit);
`;

export type Props<T extends string> = {
  stats: T[];
  player: {
    slug: string;
    pictureUrl?: string | null;
    displayName: string;
    age: number;
    position?: string;
    country: {
      code: string;
      threeLetterCode: string | null;
    };
    stats: Record<T, ReactNode>;
    to?: string;
  };
};

export const RelatedPlayer = <T extends string>({
  player,
  stats,
}: Props<T>) => {
  return (
    <Row
      style={{
        gridTemplateColumns: `auto 1fr repeat(${stats.length}, calc(5 * var(--unit)))`,
      }}
    >
      <PlayerAvatar src={player.pictureUrl} alt={player.displayName} />
      <Vertical gap={0}>
        <BodyM as="p">
          {player.to ? (
            <Link to={player.to}>{player.displayName}</Link>
          ) : (
            player.displayName
          )}
        </BodyM>
        <StyledBodyS as="p" color="var(--c-nd-600)">
          {player.position && (
            <>
              <span>{player.position}</span>•
            </>
          )}
          <span>{player.age}</span>
          •
          <Country size={1.5} {...player.country} />
        </StyledBodyS>
      </Vertical>
      {stats.map(stat => (
        <BodyM as="div" key={stat}>
          {player.stats[stat]}
        </BodyM>
      ))}
    </Row>
  );
};
